'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidWatch = function IoAndroidWatch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 20c0 4-1.9 7.5-4.8 9.8l-1.4 9h-12.5l-1.5-9c-2.9-2.3-4.8-5.8-4.8-9.8s1.9-7.5 4.8-9.8l1.5-8.9h12.5l1.4 8.9c2.9 2.3 4.8 5.8 4.8 9.8z m-21.9 0c0 5.2 4.2 9.4 9.4 9.4s9.4-4.2 9.4-9.4-4.2-9.4-9.4-9.4-9.4 4.2-9.4 9.4z' })
        )
    );
};

exports.default = IoAndroidWatch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-watch.js
// module id = 1956
// module chunks = 0